import React from 'react';
import { MdContentCopy } from 'react-icons/md';
import Tooltip from '../Tooltip';
import { useCopyToClipboard } from 'usehooks-ts';
import { DataGrid } from 'devextreme-react/data-grid';
import { sendNotification } from '@molecules/Notifications';
import { TableColumn } from '@models/Forms/IForms';

export interface CopyColumnContentButtonProps {
    column: TableColumn;
    gridRef: React.RefObject<DataGrid<any, any> | null>;
    separator: string;
}

const CopyColumnContentButton: React.FC<CopyColumnContentButtonProps> = ({
    column,
    gridRef,
    separator,
}: CopyColumnContentButtonProps) => {
    const [, copyToClipboard] = useCopyToClipboard();

    const onClick = async (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        try {
            const gridItems = gridRef.current?.instance.getDataSource().items();
            const result = gridItems
                ?.map((item) => item[column.key])
                .filter((x) => x)
                .join(separator || ',');
            if (result) {
                await copyToClipboard(result);
                sendNotification(
                    {
                        title: 'Скопировано',
                        variant: 'green',
                    },
                    1500,
                );
            } else {
                sendNotification(
                    {
                        title: 'Нет данных для копирования',
                        variant: 'yellow',
                    },
                    1500,
                );
            }
        } catch (e: any) {
            console.log(e);
            sendNotification(
                {
                    title: 'Ошибка копирования',
                    message: e.message,
                    variant: 'red',
                },
                3000,
            );
        }
    };

    return (
        <>
            <Tooltip openDelay={100} background="black" position="bottom">
                <MdContentCopy size="16" onClick={onClick} />
                Скопировать содержимое столбца в буфер обмена
            </Tooltip>
        </>
    );
};

export default CopyColumnContentButton;
